import React from 'react';
import { useSelector } from 'react-redux';

import { HomeNoEBankingActivated } from './HomeNoEBankingActivated';
import { HomeEBankingActivated } from './HomeEBankingActivated';
import {
  selectEbkServices,
  selectMigrationServices,
} from 'features/entities/entitiesSelectors';

export const HomeView = () => {
  const ebkServices = useSelector(selectEbkServices);
  const migrationServices = useSelector(selectMigrationServices);

  return (migrationServices.length > 0 || ebkServices.length > 0) ? (
    <HomeEBankingActivated />
  ) : (
    <HomeNoEBankingActivated />
  );
};
